import React from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom'
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class HookupsPhone extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      tourId: this.props.tourId,
      logs: this.props.logs,
      boatsRaw: this.props.boatsRaw,
      anglersRaw: this.props.anglersRaw,
      speciesRaw: this.props.speciesRaw,
      slidesToShow: this.props.slidesToShow,
			caughtFish: [],
      hookups: [],
      orientation: ''
    }
  }
  
  componentDidMount() {
    window.addEventListener('orientationchange', this.doOnOrientationChange);
    this.doOnOrientationChange()
  }
  
  componentWillUnmount() {   window.removeEventListener('orientationchange', this.doOnOrientationChange);
  }
  
  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.doOnOrientationChange);
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, speciesRaw: newProps.speciesRaw, boatsRaw: newProps.boatsRaw, anglersRaw: newProps.anglersRaw, slidesToShow: newProps.slidesToShow, tourId: newProps.tourId});
		this.getCaughtFish();
  }
	
	getCaughtFish(){
		var caughtFish = [];
		var hookups = [];
		this.state.logs.forEach((log) => {
			if(log.catchDate) {
				caughtFish.push(log);
			} else {
				hookups.push(log);
			}
		})
		this.setState({
			caughtFish,
			hookups
		})
	}
  
  doOnOrientationChange = () => {
    if(window.orientation === 90) {
      this.setState({
          orientation: 'landscape'
        })
    } else {
      this.setState({
          orientation: 'protrait'
        })
    }
  }
  
  formatDate(date) {
    var options = {
      month: 'short', day: '2-digit', hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Costa_Rica',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);

    return formattedDate;
  }
  
  elapsedTime(hookeduptime) {
    var time = new Date() - new Date(hookeduptime);
    var minutes = parseInt((time / (1000 * 60)) % 60, 10);
    var hours = parseInt((time / (1000 * 60 * 60)) % 24, 10);

    var h = (hours < 10) ? "0" + hours : hours;
    var m = (minutes < 10) ? "0" + minutes : minutes;

    return h + "Hrs " + m + "Mins";
  }
  
  render() {
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
		//	autoplay: true,
    //  autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
    };
    return (
      <div className="logs-container-phone">
				{this.state.hookups.length > 0 ? <Slider {...settings}>
          {this.state.hookups.map(log => (
          <div id='log-box-phone' 
            style={{flex: 1, padding: 1}} 
            key={log.id}>
              <div className="log-row">
              <div>
              {this.state.boatsRaw[log.boatId].photoUrl? <div id='anglerThm' 
                  style={{
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 100%',
                    width: 120, 
                    height: 80,
                    backgroundImage: 'url(' +  this.state.boatsRaw[log.boatId].photoUrl  + ')'
                  }} /> : <div id='anglerThm' 
                  style={{
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 50%',
                    width: 120, 
                    height: 80,
                    backgroundImage: 'url(' +  defaultImage  + ')'
                  }} />}
                </div>
              <div className="lp-detailsPhone">
							<div className="lp-statusBox-phone">
								{log.speciesId && this.state.speciesRaw ? <div id='speciesThm' 
									style={{
										position: 'relative',
										float: 'right',
										backgroundSize: 'contain',
										backgroundRepeat: 'no-repeat',
										backgroundPosition: '50% 50%',
										width: 80,
										height: 60,
										backgroundImage: 'url(' +  this.state.speciesRaw[log.speciesId].speciesImageUri  + ')'
									}} />  : null}
								<div className="logNamePhone">
									{log.anglerName}
								</div>
								<div className="logBoatNamePhone">
									{log.boatName}
								</div>
								<div className="hp-logTimePhone">
									<div>HOOKED UP!!</div>
									<div>{this.elapsedTime(log.hookedupDate)}</div>
								</div> 
							</div>
						</div>
            </div>
          </div>
          ))}
        </Slider> : <div>No hookups at the moment.</div> }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/comps/HookupsPhone.js